export interface Group {
  _id: string;
  name: string;
  description?: string;
  groupType: string;
  userCount?: number;
}
